import React from 'react';

interface IDeleteModalProps {
  title: string;
  subtitle: string;
  setIsOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsDelete: React.Dispatch<React.SetStateAction<boolean>>;
}

const DeleteModal: React.FC<IDeleteModalProps> = ({
  title,
  subtitle,
  setIsOpenDeleteModal,
  setIsDelete,
}) => {
  return (
    <div className='imm_admin__delete_modal'>
      <div className='delete_modal__container'>
        <div className='delete_modal__header'>
          <h4>{title}</h4>
          <p>{subtitle}</p>
        </div>
        <div className='delete_modal__actions'>
          <button className='modal__decline_btn' onClick={() => setIsOpenDeleteModal(false)}>
            Cancel
          </button>
          <button className='modal__accept_btn' onClick={() => { setIsOpenDeleteModal(false); setIsDelete(true); }}>
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;